import axios from 'axios'
import Vue from "vue"
import { getUserMenus } from '../extend/ViewRegister'

const state = {
    user: {},
    userMap: {},
    userArr: [],
    rolesAction: [],
    theme: ''
}

const mutations = {
    theme (state, theme) {
        window.sessionStorage.setItem('theme', theme)
        state.theme = theme
    },
    user (state, user) {
        state.user = user
        this.commit('theme', window.sessionStorage.getItem('theme') || user.theme)
        !user.ossToken && Vue.store.dispatch('getOssToken')
        window.sessionStorage.setItem('biz_admin', JSON.stringify(user))
        if (!user.isSingleLogin) getUserMenus()
    },
    userMap (state, map) {
        state.userMap = map
    },
    userArr (state, arr) {
        state.userArr = arr
    },
    rolesAction (state, rolesAction) {
        state.rolesAction = rolesAction
    }
}

const actions = {
    async getOssToken (content) {
        const { data } = await axios.get(`api/files/token`)
        if (data.status != 'yes') return console.error(data.msg || data.message || `获取文件服务token异常`)
        content.commit('user', { ...content.state.user, ossToken: data.data.token })
    },
    async getUserList (content) {
        const { data } = await axios.get(`/api/admins`, { params: { page: 1, limit: 900 } }).catch(error => { console.error('获取用户列表异常',error.response) })
        if (data.status != 'yes') return console.error(`获取用户列表异常`)
        const arr = data.data.data || []
        const map = {}
        arr.forEach(user => { map[user.adminId] = user.name })
        content.commit('userArr', arr)
        content.commit('userMap', map)
    },
    async getRolesAction (content) {
        if (!content.state.user.roleId) return console.error(`获取roleId异常,获取权限失败`)
        const { data } = await axios.get(`/api/roles/${content.state.user.roleId}/buttons`).catch(error => { console.error('获取权限按钮异常',error.response) })
        if (data.status != 'yes') return console.error(`获取权限按钮异常`)
        const action = data.data || []
        const rolesAction = []
        action.forEach(item => { if (item.roleId) rolesAction.push(item.code) })
        content.commit('rolesAction', rolesAction)
    }
}

export const user = {
    state,
    mutations,
    actions
}
